<template>
  <div>
    <!-- т -->
    <!-- п -->
    <v-container>
      <v-card
        width="100%"
        :class="`mx-auto ${PARTNER_CONFIG.theme_partner.cardVakans} `"
        color="#385F73"
        dark
      >
        <!-- скелетон -->
        <div v-if="ISLOAD">
          <v-skeleton-loader
            ref="skeleton"
            type="card"
            class="mx-auto"
            width="100%"
          ></v-skeleton-loader>

        </div>
        <!-- /скелетон -->

        <v-container v-if="!ISLOAD">
          <v-row
            justify="space-between"
            no-gutters
          >

            <!-- картинка вакансия -->
            <v-col
              md="6"
              xs="12"
              justify="space-between"
            >
              <v-img
                class="white--text align-end"
                :src="ONE_VACANSIJA.image"
              >
                <v-chip
                  :class="!ONE_VACANSIJA.isActual"
                  color="red"
                  text-color="white"
                  big
                >
                  <v-icon>mdi-fire</v-icon>
                  Приезд {{ ONE_VACANSIJA.priezd }}
                </v-chip>
                <v-chip
                  class="ma-1"
                  :class="ONE_VACANSIJA.isBezviz"
                  color="green"
                  text-color="white"
                  small
                >
                  <v-icon>mdi-hail</v-icon>

                  Безвиз
                </v-chip>

                <v-chip
                  class="ma-1"
                  :class="ONE_VACANSIJA.isUa"
                  color="indigo"
                  text-color="white"
                  small
                >
                  <v-icon>mdi-text-box-check-outline</v-icon>

                  UA котнтракт
                </v-chip>
              </v-img>
            </v-col>
            <!--/ картинка вакансия -->

            <!-- описание -->
            <v-col
              xs="12"
              md="5"
              justify="space-between"
            >
              <h2>{{ ONE_VACANSIJA.headerVakans }}</h2>

              <div>
                <v-card-text class="category">
                  <v-icon :class="PARTNER_CONFIG.theme_partner.iconVakans">mdi-google-maps</v-icon>
                  {{ ONE_VACANSIJA.cyty }}
                </v-card-text>
              </div>

              <div>
                <v-card-text class="category">
                  <v-icon :class="PARTNER_CONFIG.theme_partner.iconVakans">mdi-cash</v-icon>
                  {{ ONE_VACANSIJA.salary }}
                </v-card-text>
              </div>
              <div>
                <v-card-text class="category">
                  <v-icon :class="PARTNER_CONFIG.theme_partner.iconVakans">mdi-clock-time-four-outline</v-icon>
                  {{ ONE_VACANSIJA.worchours }}
                </v-card-text>
              </div>

              <div>
                <v-card-text class="category">
                  <v-icon :class="PARTNER_CONFIG.theme_partner.iconVakans">mdi-human-male-female</v-icon>
                  {{ ONE_VACANSIJA.gender }}
                </v-card-text>
              </div>
              <v-card-subtitle> {{ONE_VACANSIJA.kategory}}</v-card-subtitle>
            </v-col>
            <!-- описание -->

          </v-row>

          <!-- <v-card-subtitle>
            {{ONE_VACANSIJA.kategory}}
          </v-card-subtitle> -->

          <v-expand-transition>
            <div max-width="50%">
              <v-card-text>
                <div
                  class="bodyVakans"
                  v-html="ONE_VACANSIJA.vacansBody"
                ></div>
              </v-card-text>
            </div>
          </v-expand-transition>
        </v-container>
      </v-card>
    </v-container>
  </div>
</template>

 <script>
// export default {
//   data: () => ({
//     show: false
//   })
// };
//

import { mapActions, mapGetters } from "vuex";

export default {
  name: "Vakansija",
  metaInfo() {
    return {
      title: this.ONE_VACANSIJA.headerVakans,

      meta: [
        { property: "og:title", content: this.ONE_VACANSIJA.headerVakans },
        { property: "og:site_name", content: this.PARTNER_CONFIG.partner_name },
        { property: "og:type", content: this.ONE_VACANSIJA.vacansBody },
        { property: "og:url", content: window.location.href },
        { property: "og:image", content: this.ONE_VACANSIJA.image },
        { property: "og:description", content: this.ONE_VACANSIJA.kategory }
      ]
    };
  },

  methods: {
    ...mapActions(["GET_ONE_VAKANSIJA_FROM_API"])
  },
  computed: {
    ...mapGetters(["ONE_VACANSIJA", "ISLOAD", "PARTNER_CONFIG"])
  },
  // mounted() {
  //   if (this.ONE_VACANSIJA.length) {
  //     console.log("mounted");
  //     //let s = window.location.pathname;
  //     let s = this.$route.fullPath;
  //     //console.log(s);
  //     let param = s.split("/");
  //     //console.log(param);
  //     if (param) {
  //       // console.log(param);
  //       this.GET_ONE_VAKANSIJA_FROM_API(param[2]);
  //     } else {
  //       console.log("nemaje");
  //     }
  //   }
  // },
  activated() {
    console.log(this.metaInfo);
    // console.log(this.$route.fullPath);
    //let s = window.location.pathname;
    let s = this.$route.fullPath;
    //console.log(s);
    let param = s.split("/");
    //console.log(param);
    if (param) {
      // console.log(param);
      this.GET_ONE_VAKANSIJA_FROM_API(param[2]);
    } else {
      console.log("nemaje");
    }
  }
};
</script>

<style lang="css" scoped>
.bodyVakans {
  width: 100%;
}
iframe {
  width: 100px;
}
.categori-icon {
  color: brown;
  background-color: chartreuse;
  width: 50%;
}
.viza {
  display: none;
}
.neUa {
  display: none;
}
.neActual {
  display: none;
}
</style>